import { render, staticRenderFns } from "./TopbarSectionList.vue?vue&type=template&id=b0f455d2&scoped=true&"
import script from "./TopbarSectionList.vue?vue&type=script&lang=js&"
export * from "./TopbarSectionList.vue?vue&type=script&lang=js&"
import style0 from "./TopbarSectionList.vue?vue&type=style&index=0&id=b0f455d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f455d2",
  null
  
)

export default component.exports